import {dynamicFilterOperators} from "../dynamicFilterOperators";
import { vnTemplate } from '../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate';
import { filterDate_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template";
import * as am4charts from "@amcharts/amcharts4/charts";
import * as am4core from "@amcharts/amcharts4/core";
import {amCharts_v4_date_basic_template} from "./amCharts_v4_date_basic_template";
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {filterMultipleAutoComplete_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterMultipleAutoComplete_template";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {presetFilter_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/presetFilter_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import { filterSingle_multiLevel_selector_template } from '../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSingle_multiLevel_selector_template';
import {infoButton_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";

declare var ko: any;
declare var page: any;


export class permalinkDetails_template extends vnTemplate {

    protected presetFilter: presetFilter_template;
    protected viewsChart: amCharts_v4_date_basic_template;
    protected dateRangeFilter: filterDate_template;
    protected pagination: pagination_template;
    protected resultsInfo: resultsInfo_template;
    protected metricFilter: filterSingle_multiLevel_selector_template;
    protected rangeFilter: filterSingle_multiLevel_selector_template;
    protected annotationTooltip: infoButton_template;

    readonly metricValues = [
        {"id": "views", "name": "Views"},
        {"id": "visits", "name": "Visits"},
        {"id": "sessions", "name": "Sessions"},
    ];

    readonly rangeValues = [
        {"id": "dateFiltered", "name": "Date Filtered"},
        {"id": "lifetimeTraffic", "name": "Lifetime Traffic"},
    ];

    /**
     * @inheritDoc
     */
    protected getTemplateHtml(): string{

        return `

            <div id="report-results">
                <div class="page-header">
                    <div class="flex">
                        <button data-bind="visible: referrer() != '', event: { click: onClickBack }" class="button-default no-text icon i-left back no-after" type="button"></button>
                        <h2 class="title-page">Page Path Performance</h2>
                    </div>
                    <div class="w-url-block">
                        <div class="url-block" style="display: flex; gap: 10px;">
                            <input class="url-block-title full-icon" data-bind="value: permalink, event: { change: onPermalinkInputChange }, css: 'i-' + brandShortName()" type="text" style="height: 30px; font-size: 15px; border: none;"/>
                            <a data-bind="attr:{href: permalink}" target="_blank" class="btn btn-link"><span style="margin-right:0.5rem;" class='mobile-hidden'>Visit Page</span><span class="icon i-ext-link"></span></a>
                        </div>
                    </div>
                </div>

                <div class="w-justify block-filters filters-responsive">
                    <div class="w-left flex-none sidebar-filters-js-only">
                        <button data-bind="event: { click: onSidebarToggle }" class="button-default no-text icon i-preferences preferences no-after" type="button" title="report preferences">
                            <span class="hide-text">REPORT PREFERENCES</span>
                        </button>
                        <nav class="sidebar-default" data-bind="css: {'is-open': sidebarToggle()}">
                            <div class="sidebar-default-header">
                                <span class="label-default sidebar-default-header icon i-preferences">Report Preferences</span>
                                <button data-bind="event: { click: onSidebarToggle }" type="button" class="btn-close-default icon i-close"><span></span></button>
                            </div>

                            <div class="sidebar-default-body">
                                <div>
                                    <span class="label-default icon i-intervals">Interval</span>
                                    <ul class="sidebar-default-list">
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Hourly">
                                                <span>Hourly</span>
                                                <input type="radio" id="radio-hourly" name="switch-time-group" value="hourly" data-bind="event: {change: onTimeGroupSwitch.bind($data, 'hourly')}, checked: timeGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Daily">
                                                <span>Daily</span>
                                                <input type="radio" id="radio-daily" name="switch-time-group" value="daily" data-bind="event: {change: onTimeGroupSwitch.bind($data, 'daily')}, checked: timeGroupSwitch"/>
                                            </label>
                                        </li>
                                    </ul>
                                </div>
                                <div>
                                    <span class="label-default icon i-dimensions">Dimensions</span>
                                    <ul class="sidebar-default-list">
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Default">
                                                <span>Default</span>
                                                <input type="radio" id="radio-dimension-time" name="switch-dimension-group" value="time" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'time')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Device">
                                                <span>Device</span>
                                                <input type="radio" id="radio-dimension-device" name="switch-dimension-device" value="device" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'device')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Traffic Classification">
                                                <span>Traffic Classification</span>
                                                <input type="radio" id="radio-dimension-trafficClassification" name="switch-dimension-trafficClassification" value="trafficClassification" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'trafficClassification')}, checked: dimensionGroupSwitch "/>
                                            </label>
                                        </li>                                          
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Operating System">
                                                <span>Operating System</span>
                                                <input type="radio" id="radio-dimension-os" name="switch-dimension-os" value="os" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'os')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Browser">
                                                <span>Browser</span>
                                                <input type="radio" id="radio-dimension-browser" name="switch-dimension-browser" value="browser" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'browser')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Ad Block">
                                                <span>Ad Block</span>
                                                <input type="radio" id="radio-dimension-adBlockerStatus" name="switch-dimension-adBlockerStatus" value="adBlockerStatus" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'adBlockerStatus')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>                                                                                                                                                        
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Geo">
                                                <span>Geo</span>
                                                <input type="radio" id="radio-dimension-geo" name="switch-dimension-geo" value="geo" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'geo')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="AMP">
                                                <span>AMP</span>
                                                <input type="radio" id="radio-dimension-ampStatus" name="switch-dimension-ampStatus" value="ampStatus" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'ampStatus')}, checked: dimensionGroupSwitch "/>
                                            </label>
                                        </li>                                                                                    
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Referrer">
                                                <span>Referrer</span>
                                                <input type="radio" id="radio-dimension-referrer" name="switch-dimension-referrer" value="referrer" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'referrer')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>                                      
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Login Status">
                                                <span>Login Status</span>
                                                <input type="radio" id="radio-dimension-loginStatus" name="switch-dimension-loginStatus" value="loginStatus" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'loginStatus')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Plan">
                                                <span>Plan</span>
                                                <input type="radio" id="radio-dimension-plan" name="switch-dimension-plan" value="plan" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'plan')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>                                                                                                                                                                                                                                                                                        
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Identity Source">
                                                <span>Identity Source</span>
                                                <input type="radio" id="radio-dimension-identity-source" name="switch-dimension-identity-source" value="identitySource" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'identitySource')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Robot Name">
                                                <span>Robot Name</span>
                                                <input type="radio" id="radio-dimension-robotName" name="switch-dimension-robotName" value="robotName" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'robotName')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Robot Category">
                                                <span>Robot Category</span>
                                                <input type="radio" id="radio-dimension-robotCategory" name="switch-dimension-robotCategory" value="robotCategory" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'robotCategory')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>     
                                    </ul>
                                </div>
                                <div>
                                    <span class="label-default icon i-dimensions">UTMs</span>
                                    <ul class="sidebar-default-list">                                   
                                        <li>
                                            <label class="label-checkbox-menu-default" title="UTM Campaign">
                                                <span>UTM Campaign</span>
                                                <input type="radio" id="radio-dimension-utmCampaign" name="switch-dimension-utmCampaign" value="utmCampaign" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'utmCampaign')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="UTM Medium">
                                                <span>UTM Medium</span>
                                                <input type="radio" id="radio-dimension-utmMedium" name="switch-dimension-utmMedium" value="utmMedium" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'utmMedium')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="UTM Source">
                                                <span>UTM Source</span>
                                                <input type="radio" id="radio-dimension-utmSource" name="switch-dimension-utmSource" value="utmSource" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'utmSource')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                    </ul>
                                </div>
                                <div>
                                    <span class="label-default icon i-dimensions">Custom Dimensions</span>
                                    <ul class="sidebar-default-list">
                                         <!-- ko foreach: customDimensionsNames -->
                                            <li>
                                                <label class="label-checkbox-menu-default" title="Default" data-bind="attr: {title: name}">
                                                    <span data-bind="text: name"></span>
                                                    <input type="radio" data-bind="attr: { id: 'radio-dimension-' + name, name: 'switch-dimension-' + name, value: name }, event: { change: $parent.onDimensionGroupSwitch.bind($parent, name) }, checked: $parent.dimensionGroupSwitch"/>                            </label>
                                            </li>
                                        <!-- /ko -->
                                    </ul>
                                </div>
                            </div>

                        </nav>
                    </div>

                    <nav class="sidebar-default sidebar-default-right" data-bind="css:{'is-open': isFiltersOpen()}">
                        <div class="sidebar-default-header">
                            <span class="label-default sidebar-default-header icon i-filters">Filters</span>
                            <button type="button" class="btn-close-default icon i-close" data-bind="event: { click: toggleOpenFilters }"><span></span></button>
                        </div>

                        <div class="sidebar-default-body">

                            <div>

                                <!-- ko foreach: dynamicFiltersGrouped -->

                                    <span class="form-label" data-bind="text: categoryName"></span>

                                    <div class="dynamic-filters w-add-filters-list">
                                        <!-- ko foreach: Object.values(names) -->

                                            <div class="filter-group">

                                                <div class="checkbox-group">
                                                    <label class="icon i-dropdown-simple">
                                                        <input class="expected" type="checkbox" />
                                                    </label>
                                                </div>

                                                <!-- ko foreach: filters -->

                                                    <!-- ko if: type === 'multiSelect' -->
                                                        <div data-bind="template: {name: 'multiSelector-template', data: filter.getTemplateViewModel()}" class="has-multi"></div>
                                                    <!-- /ko -->

                                                    <!-- ko if: type === 'autoCompleteMultiSelect' -->
                                                        <div data-bind="template: {name: 'filterMultipleAutoComplete-template', data: filter.getTemplateViewModel()}"></div>
                                                    <!-- /ko -->

                                                    <!-- ko if: type === 'searchField' -->
                                                        <div data-bind="template: {name: 'filterSimple-template', data: filter.getTemplateViewModel()}"></div>
                                                    <!-- /ko -->

                                                    ${dynamicFilterOperators.html}

                                                <!-- /ko -->
                                            </div> <!-- End filter-group -->
                                        <!-- /ko -->
                                    </div>
                                <!-- /ko -->

                            </div>
                        </div>
                    </nav>

                    <div class="w-right flex-all block-default">
                        <div class="w-justify full-width">
                            <div class="w-left">
                                <div>
                                     ${this.dateRangeFilter.getHtmlBuild()}
                                </div>
                                <button class="icon i-filters no-after filterToggle-btn" data-bind="event: {click: toggleOpenFilters}">Filters</button>
                            </div>

                            <div class="w-right ">
                                <div class="w-filter-preset hide-mobile" data-bind="visible: false, event: { mouseover: onMouseOverPreset, mouseout: onMouseOutPreset}">
                                    ` + this.presetFilter.getHtmlBuild() + `
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="w-justify">
                    <div class="w-left">
                        <div class="w-filters-selected">
                            <div id="filters-selected" class="filters-selected">
                                <!-- ko foreach: dynamicFilters -->
                                    <div data-bind="attr: { id: 'selected-' + name }, css: {'filter-excluded': filter.getTemplateViewModel().filterOperator() === 'exclude'}"></div>
                                <!-- /ko -->
                            </div>
                        </div>
                    </div>
                </div>


                <div data-bind="visible: indicatorsDateRangeEmpty" class="w-msg-block alert">
                    <div class="msg-block">
                        <span class="icon i-notice-alert" data-bind="text: 'Daily data for this page path is not available yet'"></span>
                    </div>
                </div>

                <!-- ko if: sampledDatesData() && sampledDatesData().length > 0 -->
                    <div class="w-block-message plus theme-light">
                        <div class="block-message-content">
                            <p><strong>Note:</strong> The selected date range includes periods where data was sampled.</p>
                        </div>
                    </div>
                <!-- /ko -->

                <section class="w-graph block-default rogue">

                    <div class="w-justify" style="width: 100%;">
                        <div class="block-filters w-left">
                            ${this.metricFilter.getHtmlBuild()}
                        </div>

                        <div class="w-right" style="margin-right: 1rem;" data-bind= "visible: timelineAnnotationsData().length">
                            <span class="label-annotation"></span>
                            <div class="w-tooltips-adv auto-height short pos-top-left">
                                ${this.annotationTooltip.getHtmlBuild()}
                            </div>
                        </div>
                    </div>

                    <div class="graph" id="indicatorsByDate-results"  data-bind="css: { loading: false }">
                        ${this.viewsChart.getHtmlBuild()}
                    </div>
                </section>

                <section>
                    <div class="w-justify block-default block-filters padding-left">
                       <div class="w-left">
                            <div>
                                ${this.rangeFilter.getHtmlBuild()}
                            </div>
                        </div>
                    </div>

                    <div class="w-inner-content permalink-details">

                        <div class="content-right">
                            <div id="indicatorsTotals-results">

                                <div class="highlight-page" data-bind="visible: Object.keys(indicatorsTotals()).length > 0">

                                    <div class="highlight-item">
                                        <span class="item-title">Views</span>
                                        <strong class="item-value icon" data-bind="text: Number(indicatorsTotals().views).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">0</strong>
                                    </div>
                                    <div class="highlight-item">
                                        <span class="item-title">Visits</span>
                                        <strong class="item-value icon" data-bind="text: Number(indicatorsTotals().visits).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">0</strong>
                                    </div>
                                    <div class="highlight-item">
                                        <span class="item-title">Sessions</span>
                                        <strong class="item-value icon " data-bind="text: Number(indicatorsTotals().sessions).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})">0</strong>
                                    </div>
                                </div>

                                <div class="w-tables">

                                        <table class="list-results" data-bind="visible: Object.keys(indicatorsTotals()).length > 0">
                                            <thead>
                                                <tr class="list-header-row">
                                                    <th colspan="3"><span>Device</span></th>
                                                </tr>
                                                <tr>
                                                    <th></th>
                                                    <th><span>Mobile</span></th>
                                                    <th><span>Desktop</span></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <th><span>Views</span></th>
                                                    <td>
                                                        <span data-bind="text: Number(indicatorsTotals().viewsMobile).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                                        <span data-bind="text: '(' + Number(indicatorsTotals().views > 0 ? (indicatorsTotals().viewsMobile/indicatorsTotals().views * 100) : 0).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%)'"></span>
                                                    </td>
                                                    <td>
                                                        <span  data-bind="text: Number(indicatorsTotals().viewsDesktop).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                                        <span data-bind="text: '(' + Number(indicatorsTotals().views > 0 ? (indicatorsTotals().viewsDesktop/indicatorsTotals().views * 100) : 0).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%)'"></span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th><span>Visits</span></th>
                                                    <td>
                                                        <span data-bind="text: Number(indicatorsTotals().visitsMobile).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                                        <span data-bind="text: '(' + Number(indicatorsTotals().visits > 0 ? (indicatorsTotals().visitsMobile/indicatorsTotals().visits * 100) : 0).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%)'"></span>
                                                    </td>
                                                    <td>
                                                        <span data-bind="text: Number(indicatorsTotals().visitsDesktop).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                                        <span data-bind="text: '(' + Number(indicatorsTotals().visits > 0 ? (indicatorsTotals().visitsDesktop/indicatorsTotals().visits * 100) : 0).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%)'"></span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th><span>Sessions</span></th>
                                                    <td>
                                                        <span data-bind="text: Number(indicatorsTotals().sessionsMobile).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                                        <span data-bind="text: '(' + Number(indicatorsTotals().sessions > 0 ? (indicatorsTotals().sessionsMobile/indicatorsTotals().sessions * 100) : 0).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%)'"></span>
                                                    </td>
                                                    <td>
                                                        <span data-bind="text: Number(indicatorsTotals().sessionsDesktop).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                                        <span data-bind="text: '(' + Number(indicatorsTotals().sessions > 0 ? (indicatorsTotals().sessionsDesktop/indicatorsTotals().sessions * 100) : 0).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%)'"></span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>


                                        <table class="list-results" data-bind="visible: Object.keys(indicatorsTotals()).length > 0">
                                            <thead>
                                                <tr class="list-header-row">
                                                    <th colspan="3"><span>OS</span></th>
                                                </tr>
                                                <tr>
                                                    <th></th>
                                                    <th><span>Android</span></th>
                                                    <th><span>iOS</span></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <th><span>Views</span></th>
                                                    <td>
                                                        <span data-bind="text: Number(indicatorsTotals().viewsAndroid).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                                        <span data-bind="text: '(' + Number(indicatorsTotals().views > 0 ? (indicatorsTotals().viewsAndroid/indicatorsTotals().views * 100) : 0).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%)'"></span>
                                                    </td>
                                                    <td>
                                                        <span data-bind="text: Number(indicatorsTotals().viewsIOS).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                                        <span data-bind="text: '(' + Number(indicatorsTotals().views > 0 ? (indicatorsTotals().viewsIOS/indicatorsTotals().views * 100) : 0).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%)'"></span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th><span>Visits</span></th>
                                                    <td>
                                                        <span data-bind="text: Number(indicatorsTotals().visitsAndroid).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                                        <span data-bind="text: '(' + Number(indicatorsTotals().visits > 0 ? (indicatorsTotals().visitsAndroid/indicatorsTotals().visits * 100) : 0).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%)'"></span>
                                                    </td>
                                                    <td>
                                                        <span data-bind="text: Number(indicatorsTotals().visitsIOS).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                                        <span data-bind="text: '(' + Number(indicatorsTotals().visits > 0 ? (indicatorsTotals().visitsIOS/indicatorsTotals().visits * 100) : 0).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%)'"></span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th><span>Sessions</span></th>
                                                    <td>
                                                        <span data-bind="text: Number(indicatorsTotals().sessionsAndroid).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                                        <span data-bind="text: '(' + Number(indicatorsTotals().sessions > 0 ? (indicatorsTotals().sessionsAndroid/indicatorsTotals().sessions * 100) : 0).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%)'"></span>
                                                    </td>
                                                    <td>
                                                        <span data-bind="text: Number(indicatorsTotals().sessionsIOS).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                                        <span data-bind="text: '(' + Number(indicatorsTotals().sessions > 0 ? (indicatorsTotals().sessionsIOS/indicatorsTotals().sessions * 100) : 0).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%)'"></span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>


                                        <table class="list-results" data-bind="visible: Object.keys(indicatorsTotals()).length > 0">
                                            <thead>
                                                <tr class="list-header-row">
                                                    <th colspan="3"><span>Geo</span></th>
                                                </tr>
                                                <tr>
                                                    <th></th>
                                                    <th><span>US</span></th>
                                                    <th><span>Prime</span></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <th><span>Views</span></th>
                                                    <td>
                                                        <span data-bind="text: Number(indicatorsTotals().viewsUS).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                                        <span data-bind="text: '(' + Number(indicatorsTotals().views > 0 ? (indicatorsTotals().viewsUS/indicatorsTotals().views * 100) : 0).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%)'"></span>
                                                    </td>
                                                    <td>
                                                        <span data-bind="text: Number(indicatorsTotals().viewsPrime).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                                        <span data-bind="text: '(' + Number(indicatorsTotals().views > 0 ? (indicatorsTotals().viewsPrime/indicatorsTotals().views * 100) : 0).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%)'"></span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th><span>Visits</span></th>
                                                    <td>
                                                        <span data-bind="text: Number(indicatorsTotals().visitsUS).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                                        <span data-bind="text: '(' + Number(indicatorsTotals().visits > 0 ? (indicatorsTotals().visitsUS/indicatorsTotals().visits * 100) : 0).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%)'"></span>
                                                    </td>
                                                    <td>
                                                        <span data-bind="text: Number(indicatorsTotals().visitsPrime).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                                        <span data-bind="text: '(' + Number(indicatorsTotals().visits > 0 ? (indicatorsTotals().visitsPrime/indicatorsTotals().visits * 100) : 0).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%)'"></span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th><span>Sessions</span></th>
                                                    <td>
                                                        <span data-bind="text: Number(indicatorsTotals().sessionsUS).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                                        <span data-bind="text: '(' + Number(indicatorsTotals().sessions > 0 ? (indicatorsTotals().sessionsUS/indicatorsTotals().sessions * 100) : 0).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%)'"></span>
                                                    </td>
                                                    <td>
                                                        <span data-bind="text: Number(indicatorsTotals().sessionsPrime).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                                        <span data-bind="text: '(' + Number(indicatorsTotals().sessions > 0 ? (indicatorsTotals().sessionsPrime/indicatorsTotals().sessions * 100) : 0).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%)'"></span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>


                                        <table class="list-results" data-bind="visible: Object.keys(indicatorsTotals()).length > 0">
                                            <thead>
                                                <tr class="list-header-row">
                                                    <th colspan="3"><span>Login</span></th>
                                                </tr>
                                                <tr>
                                                    <th></th>
                                                    <th><span>Logged-In</span></th>
                                                    <th><span>Logged-Out</span></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <th><span>Views</span></th>
                                                    <td>
                                                        <span data-bind="text: Number(indicatorsTotals().viewsLoggedIn).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                                        <span data-bind="text: '(' + Number(indicatorsTotals().views > 0 ? (indicatorsTotals().viewsLoggedIn/indicatorsTotals().views * 100) : 0).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%)'"></span>
                                                    </td>
                                                    <td>
                                                        <span data-bind="text: Number(indicatorsTotals().views-indicatorsTotals().viewsLoggedIn).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                                        <span data-bind="text: '(' + Number(indicatorsTotals().views > 0 ? ((indicatorsTotals().views-indicatorsTotals().viewsLoggedIn)/indicatorsTotals().views * 100) : 0).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%)'"></span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th><span>Visits</span></th>
                                                    <td>
                                                        <span data-bind="text: Number(indicatorsTotals().visitsLoggedIn).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                                        <span data-bind="text: '(' + Number(indicatorsTotals().visits > 0 ? (indicatorsTotals().visitsLoggedIn/indicatorsTotals().visits * 100) : 0).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%)'"></span>
                                                    </td>
                                                    <td>
                                                        <span data-bind="text: Number(indicatorsTotals().visits-indicatorsTotals().visitsLoggedIn).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                                        <span data-bind="text: '(' + Number(indicatorsTotals().visits > 0 ? ((indicatorsTotals().visits-indicatorsTotals().visitsLoggedIn)/indicatorsTotals().visits * 100) : 0).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%)'"></span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th><span>Sessions</span></th>
                                                    <td>
                                                        <span data-bind="text: Number(indicatorsTotals().sessionsLoggedIn).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                                        <span data-bind="text: '(' + Number(indicatorsTotals().sessions > 0 ? (indicatorsTotals().sessionsLoggedIn/indicatorsTotals().sessions * 100) : 0).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%)'"></span>
                                                    </td>
                                                    <td>
                                                        <span data-bind="text: Number(indicatorsTotals().sessions-indicatorsTotals().sessionsLoggedIn).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                                        <span data-bind="text: '(' + Number(indicatorsTotals().sessions > 0 ? ((indicatorsTotals().sessions-indicatorsTotals().sessionsLoggedIn)/indicatorsTotals().sessions * 100) : 0).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%)'"></span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </div>
            <footer class="default-footer">
                <span class="logo-short"></span>
                <span class="footer-text">©${new Date().getFullYear()} ValServ Inc. All rights reserved.</span>
                <span>|</span>
                <a href="https://sentinelpro.com/pages/privacy-policy" target="_blank">Privacy Policy</a>
            </footer>
        `;
    }

    /**
     * @inheritDoc
     */
    protected initPartial(): void{

        this.presetFilter = new presetFilter_template("presetFilter", this.getTemplateViewModel(), this.caller);
        this.presetFilter.setType('permalinkDetails');

        this.pagination   = new pagination_template('pagination', this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 35;

        this.resultsInfo  = new resultsInfo_template('resultsInfo', this.getTemplateViewModel(), this.caller);

        // Get the current date
        const currentDate = new Date();

        // Get the date for yesterday
        const yesterday = new Date(currentDate);
        yesterday.setDate(currentDate.getDate() - 1);

        // Get the date 7 days before yesterday
        const lastWeekStart = new Date(yesterday);
        lastWeekStart.setDate(yesterday.getDate() - 6);

        /* const twoDaysAgo = new Date(yesterday);
        twoDaysAgo.setDate(yesterday.getDate() - 1); */

        this.dateRangeFilter = new filterDate_template("dateRangeFilter", this.getTemplateViewModel(), this.caller);
        this.dateRangeFilter.setStartPickerId('dateRangeStartDatePicker');
        this.dateRangeFilter.setEndPickerId('dateRangeEndDatePicker');
        this.dateRangeFilter.setDateRange(currentDate, currentDate);

        // Get the date 7 days before last week start
        const weekBeforeLastStart = new Date(lastWeekStart);
        weekBeforeLastStart.setDate(lastWeekStart.getDate() - 2);

        this.viewsChart = new amCharts_v4_date_basic_template('viewsChart', this.getTemplateViewModel(), this.caller);

        this.metricFilter = new filterSingle_multiLevel_selector_template('metricFilter', this.getTemplateViewModel(), this.caller);
        this.metricFilter.setLabel('Metric');

        this.rangeFilter = new filterSingle_multiLevel_selector_template('rangeFilter', this.getTemplateViewModel(), this.caller);
        this.rangeFilter.setLabel('Range');

        this.annotationTooltip = new infoButton_template('annotationTooltip', this.getTemplateViewModel(), this.caller)
        this.annotationTooltip.setContent('');

        window.addEventListener('click', event => {

            const sidebarFilters = document.querySelector('.sidebar-filters-js-only');
            const addFiltersDropdown = document.querySelector('.sidebar-default-right');
            const addFiltersButton = document.querySelector('.filterToggle-btn');

            if(!sidebarFilters?.contains(event.target as Element)){
                this.getTemplateViewModel().sidebarToggle(false);
            }

            if(!addFiltersDropdown?.contains(event.target as Element) && !addFiltersButton?.contains(event.target as Element) && !(event.target as Element).closest('.form-auto-item') && !(event.target as Element).closest('.btn-f-s')){
                this.getTemplateViewModel().isFiltersOpen(false);
            }
        })
    }

    /**
     * @inheritDoc
     */
    protected getTemplateName(): string{

        return 'permalinkDetails_template';
    }

    /**
     * @inheritDoc
     */
    public buildViewModel(): Object{

        let self = this;

        return {
            sampledDatesData: ko.observableArray([]),
            dynamicFiltersData: ko.observableArray([]),
            dynamicFilters: ko.observableArray([]),
            dynamicFiltersGroupedByName: ko.observableArray([]),
            dynamicFiltersGrouped: ko.observableArray([]),
            customDimensionsNames: ko.observableArray([]),
            dateStartSelected: ko.observable(),
            dateEndSelected: ko.observable(),
            isFiltersOpen: ko.observable(false),
            deviceView: ko.observable('desktop'),
            brandShortName: ko.observable(''),
            brand: ko.observable(''),
            permalink: ko.observable(''),
            referrer: ko.observable(''),
            graphAxes: ko.observableArray([]),
            graphLines: ko.observableArray([]),
            indicatorsDateRange: ko.observableArray([]),
            indicatorsDateRangeEmpty: ko.observable(false),
            indicatorsTotals: ko.observableArray([]),
            timelineAnnotationsData: ko.observableArray([]),
            indicatorGroupSwitch: ko.observable('sessions'),
            timeGroupSwitch: ko.observable('hourly'),
            dimensionGroupSwitch: ko.observable('time'),
            rangeGroupSwitch: ko.observable('dateFiltered'),
            viewMode: ko.observable('traffic'),
            indicatorDataLoaded: ko.observable(false),
            isPresetVisible: ko.observable(false),
            sidebarToggle: ko.observable(false),
            onMouseOverPreset : function () {
                
                self.onMouseOverPreset();
            },
            onMouseOutPreset : function () {
                
                self.onMouseOutPreset();
            },
            onIndicatorGroupSwitch: function(data, event){

                self.onIndicatorGroupSwitch();
            },
            onTimeGroupSwitch: function(data, event){

                self.onTimeGroupSwitch(data, event);
            },
            onDimensionGroupSwitch: function(data, event){

                self.onDimensionGroupSwitch(data, event);
            },
            onRangeGroupSwitch: function(data, event){

                self.onRangeGroupSwitch(data, event);
            },
            onClickBack: function(){

                self.onClickBack();
            },
            onPermalinkInputChange: function(data,event){

                self.onPermalinkInputChange(data, event);
            },
            toggleOpenFilters: function(data){
                self.toggleOpenFilters();
            },
            onSidebarToggle: function(){
                self.onSidebarToggle();
            }
        }


    }

    public toggleOpenFilters(){

        this.getTemplateViewModel().isFiltersOpen(!this.getTemplateViewModel().isFiltersOpen());
    }

    private onSidebarToggle(){

        this.getTemplateViewModel().sidebarToggle(!this.getTemplateViewModel().sidebarToggle());
    }

    public setSampledDatesData(sampledDatesData) {

        this.getTemplateViewModel().sampledDatesData(sampledDatesData);
    }

    public setDynamicFilters(dynamicFiltersData: Array<any>){
    
        let i = 0;
        let dynamicFilters = [];

        for (let category in dynamicFiltersData) {

            if (dynamicFiltersData.hasOwnProperty(category)) {

                let filtersData = dynamicFiltersData[category];

                filtersData.forEach((filterData) => {

                    let filter, filterId;

                    // multi select
                    if(filterData.type === 'multiSelect'){

                        filterId = filterData.id;
                        filter = new multipleSelector_template(filterId, this.getTemplateViewModel(), this.caller);
                        filter.setLabel(filterData.name);
                        filter.setTagContainerId('selected-' + filterData.name);
                        filter.setTagContainerCaption('Selected ' + filterData.name + ':');
                        filter.setItems(filterData.values);
                        filter.setShowCount(true);
                        filter.setShowClear(true);

                        if(filterData.hasSearchFilter){

                            filter.setContainSearchEnabled(true);
                        }

                        dynamicFilters.push({
                            filter: filter,
                            filterId: filterId,
                            name: filterData.name,
                            type: filterData.type,
                            category: filterData.category,
                            categoryName: filterData.categoryName
                        });
                    }
                    // multi select autocomplete
                    else if(filterData.type === 'autoCompleteMultiSelect'){

                        filterId = filterData.id;
                        filter = new filterMultipleAutoComplete_template(filterId, this.getTemplateViewModel(), this.caller);
                        filter.setIsVisible(1);
                        //filter.setPlaceHolderText(filterData.name);
                        filter.setIcon("i-tag-a");
                        filter.setTagContainerId('selected-' + filterData.name);
                        filter.setTagContainerCaption('Selected ' + filterData.name + ':');
                        filter.setMinInputSuggestionLength(2);
                        filter.setLabel(filterData.name);
                        filter.setShowCount(true);
                        filter.setShowClear(true);

                        if(filterData.hasSearchFilter){

                            filter.setContainSearchEnabled(true);
                        }

                        dynamicFilters.push({
                            filter: filter,
                            filterId: filterId,
                            name: filterData.name,
                            type: filterData.type,
                            category: filterData.category,
                            categoryName: filterData.categoryName
                        });
                    }
                    else if(filterData.type === 'searchField'){
                        
                        filterId = filterData.id;
                        filter = new filterSimple_template(filterId, this.getTemplateViewModel(), this.caller);
                        filter.setLabel(filterData.name);

                        dynamicFilters.push({
                            filter: filter,
                            filterId: filterId,
                            name: filterData.name,
                            type: filterData.type,
                            category: filterData.category,
                            categoryName: filterData.categoryName
                        });
                    }
                })
            }
        }

        dynamicFilterOperators.initialize(dynamicFilters, this.caller);
        this.getTemplateViewModel().dynamicFilters(dynamicFilters);

        let dynamicFiltersGrouped = Object.values(dynamicFilters.reduce((acc, item) => {

            // Check if the category already exists
            if (!acc[item.categoryName]) {
                acc[item.categoryName] = {
                    categoryName: item.categoryName,
                    names: {}
                };
            }

            // Check if the name already exists within the category
            if (!acc[item.categoryName].names[item.name]) {
                acc[item.categoryName].names[item.name] = {
                    name: item.name,
                    filters: []
                };
            }

            // Push the filter into the correct name group
            acc[item.categoryName].names[item.name].filters.push({
                type: item.type,
                filter: item.filter,
                filterId: item.filterId
            });

            return acc;
        }, {}));

        this.getTemplateViewModel().dynamicFiltersGrouped(dynamicFiltersGrouped);

        let dynamicFiltersGroupedByName = Object.values(dynamicFilters.reduce((acc, item) => {

            if (!acc[item.name]) {
                acc[item.name] = { name: item.name, category: item.category, filters: [] };
            }
            acc[item.name].filters.push({ type: item.type, filter: item.filter, filterId: item.filterId });
            return acc;
        }, {}));

        this.getTemplateViewModel().dynamicFiltersGroupedByName(dynamicFiltersGroupedByName);

        // Custom dimension names
        let customDimensionsNames = dynamicFilters.reduce((acc, item) => {
            if (item.category === "Custom Dimensions" && !acc.find(obj => obj.name === item.name)) {
                acc.push({ name: item.filterId.split('-')[0] });
            }
            return acc;
        }, []);

        this.getTemplateViewModel().customDimensionsNames(customDimensionsNames);
    }

    public setDynamicAutoCompleteMultiSelectFilterItems(filterId, items){

        let dynamicFilters = this.getTemplateViewModel().dynamicFilters();
        let filter = dynamicFilters.find(filters => filters.filter.idElement === filterId).filter;
        if (filter) {

            filter.setItems(items);
            this.getTemplateViewModel().dynamicFilters(dynamicFilters);
        }
        filter.setItems(items);
    }

    /**
     * @inheritDoc
     */
    public getViewModelForRequest(): Object{

        let selectedDynamicFilters = [];
        let dynamicFilters = this.getTemplateViewModel().dynamicFilters();
        if(typeof dynamicFilters !== "undefined" && dynamicFilters !== null && Object.keys(dynamicFilters).length !== 0) {

            for(let dynamicFilter of dynamicFilters) {

                if(dynamicFilter.type === 'multiSelect') {

                    let items = dynamicFilter.filter.getTemplateViewModel().items();
                    let searchKeyword = dynamicFilter.filter.getContainSearchFilterKeyword();
                    let selectedIds = dynamicFilter.filter.getTemplateViewModel().selectedItems();
                    let filteredItems = items.filter(item => selectedIds.includes(item.id));

                    if(filteredItems.length > 0 || searchKeyword != '') {

                        selectedDynamicFilters.push({

                            [dynamicFilter.category]: {

                                [dynamicFilter.name]: {

                                    id: dynamicFilter.filterId,
                                    type: dynamicFilter.type,
                                    items: filteredItems,
                                    keyword: searchKeyword
                                }
                            }
                        });
                    }
                }
                else if(dynamicFilter.type === 'autoCompleteMultiSelect') {

                    let selectedIds = dynamicFilter.filter.getTemplateViewModel().selectedItems();
                    let searchKeyword = dynamicFilter.filter.getContainSearchFilterKeyword();
                    let filteredItems = selectedIds;

                    if(filteredItems.length > 0 || searchKeyword != '') {

                        selectedDynamicFilters.push({

                            [dynamicFilter.category]: {

                                [dynamicFilter.name]: {

                                    id: dynamicFilter.filterId,
                                    type: dynamicFilter.type,
                                    items: filteredItems,
                                    keyword: searchKeyword
                                }
                            }
                        });
                    }
                }
                else if(dynamicFilter.type === 'searchField') {
                    
                    let searchKeyword = dynamicFilter.filter.getTemplateViewModel().filterKeyword();

                    if(searchKeyword) {

                        selectedDynamicFilters.push({
                            
                            [dynamicFilter.category]: {
                                [dynamicFilter.name]: {
                                    id: dynamicFilter.filterId,
                                    type: dynamicFilter.type,
                                    keyword: searchKeyword
                                }
                            }
                        });
                    }
                }
            }
        }

        return {
            filters : {
                permalink: this.getTemplateViewModel().permalink(),
                brand: this.getTemplateViewModel().brand(),
                dateFilterType: this.getTemplateViewModel().dateRangeFilter.selectedFilter(),
                startDate: this.getTemplateViewModel().dateRangeFilter.startDate(),
                endDate: this.getTemplateViewModel().dateRangeFilter.endDate(),
                startDateRange: this.getTemplateViewModel().dateRangeFilter.fromRange(),
                endDateRange: this.getTemplateViewModel().dateRangeFilter.toRange(),
                dimensionGroupSwitch: this.getTemplateViewModel().dimensionGroupSwitch(),
                timeGroupSwitch: this.getTemplateViewModel().timeGroupSwitch(),
                indicatorGroupSwitch: this.metricFilter.getTemplateViewModel().selectedOption(),
                indicatorGroupSwitchText: this.metricFilter.getTemplateViewModel().selectedOptionText(),
                rangeGroupSwitch: this.rangeFilter.getTemplateViewModel().selectedOption(),
                rangeGroupSwitchText: this.rangeFilter.getTemplateViewModel().selectedOptionText(),
                viewMode: this.getTemplateViewModel().viewMode(),
                selectedDynamicFilters: dynamicFilterOperators.forRequest(selectedDynamicFilters, dynamicFilters)
            }
        };
    }

    /**
     * Build the date Picker calendar.
     */
    public buildDatePickerCalendar() {

        this.dateRangeFilter.buildCalendar();
    }

    public setDatesSelected(){

        this.getTemplateViewModel().dateStartSelected(this.getTemplateViewModel().dateRangeFilter.startDate());
        this.getTemplateViewModel().dateEndSelected(this.getTemplateViewModel().dateRangeFilter.endDate());
    }

    public setDefaultDevices(){

        // Select by default Mobile, Desktop, Tablet
        const filter = this.getTemplateViewModel().dynamicFilters().find(f => f.filterId == 'device-internalDimension').filter;

        let defaultDevices = ['Mobile', 'Desktop', 'Tablet'];
        let filterItems = filter.getItems().filter(i => i && defaultDevices.includes(i.name));
        let filterItemIds = filterItems.map(i => i.id);

        if(filter.getTemplateName() === 'multiSelector-template'){

            filter.setSelectedItems(filterItems);
            filter.setTags(filterItemIds, filter.getItems());
        }

        dynamicFilterOperators.setDefaultHttpStatus(this.getTemplateViewModel().dynamicFilters());
    }

    public setDeviceView(deviceView) {

        this.getTemplateViewModel().deviceView(deviceView);
    }

    public setIndicatorsData(indicatorsData) {

        // convert date strings to date objects for am4charts.
        for(let i = 0; i < indicatorsData.dateRange.data.length; i++) {

            indicatorsData.dateRange.data[i].dateData = new Date(indicatorsData.dateRange.data[i].dateData);
        }

        this.getTemplateViewModel().indicatorsDateRange(indicatorsData.dateRange);
        this.getTemplateViewModel().indicatorsDateRangeEmpty(indicatorsData.dateRange.data.length > 0 ? false : true);
    }

    public setGraphLinesInfo(graphLines) {
        
        this.getTemplateViewModel().graphLines(graphLines);
    }

    public setBrandShortName(brandShortName) {

        this.getTemplateViewModel().brandShortName(brandShortName);
    }

    public setMetricFilterItems() {

        const options = this.metricValues;

        let filterItems = options.map(o => {
            return {
                id: o.id,
                name: o.name,
                type: "",
                cssClasses: ""
            }
        });

        // set the groups manually (dont use setGroups here)
        this.metricFilter.getTemplateViewModel().groups(filterItems);

        // set default
        this.metricFilter.setSelectedOption(filterItems[2].id);
        this.metricFilter.setSelectedOptionText(filterItems[2].name);
    }

    public setRangeFilterItems() {

        const options = this.rangeValues;

        let filterItems = options.map(o => {
            return {
                id: o.id,
                name: o.name,
                type: "",
                cssClasses: ""
            }
        });

        // set the groups manually (dont use setGroups here)
        this.rangeFilter.getTemplateViewModel().groups(filterItems);

        // set default
        this.rangeFilter.setSelectedOption(filterItems[0].id);
        this.rangeFilter.setSelectedOptionText(filterItems[0].name);
    }

    public setPermalink(permalink) {

        let refbox = document.querySelector('[data-refbox="iframe"]');

        if (refbox) {
            refbox.innerHTML = `
                <iframe src="${permalink}"></iframe>
            `;
        }

        this.getTemplateViewModel().permalink(permalink);
    }

    public setIndicatorsTotalsData(indicatorsData) {

        this.getTemplateViewModel().indicatorsTotals(indicatorsData.indicatorsTotals);
    }

    public setViewModeFilterItems(viewModes): void{


    }

    public setTimelineAnnotationsData(timelineAnnotationsData) {

        for(let i = 0; i < timelineAnnotationsData.length; i++) {

            timelineAnnotationsData[i].dateOrig = timelineAnnotationsData[i].date;
            timelineAnnotationsData[i].date = new Date(timelineAnnotationsData[i].date);
        }

        this.getTemplateViewModel().timelineAnnotationsData(timelineAnnotationsData);

        // format for tooltip
        let formattedAnnotationTooltip = '<ul>';
        for(let i = 0; i < timelineAnnotationsData.length; i++) {

            let formattedDate = timelineAnnotationsData[i].dateOrig.substring(0, 10)
            if (this.getTemplateViewModel().timeGroupSwitch() == "hourly") {

                formattedDate = timelineAnnotationsData[i].dateOrig.substring(0, 13)+'H'
            }
            formattedAnnotationTooltip += '<li class="col"><strong>' + formattedDate + '</strong><p>'+ timelineAnnotationsData[i].annotation +'</p></li>';
        }
        formattedAnnotationTooltip += '</ul>';


        this.annotationTooltip.setContent(formattedAnnotationTooltip);
    }

    public clearTimelineAnnotatonData(){

        this.getTemplateViewModel().timelineAnnotationsData([]);
    }

    public onIndicatorGroupSwitch(){

        let metric = this.metricFilter.getSelectedOption();
        this.getTemplateViewModel().indicatorGroupSwitch(metric);
        this.caller.getReportData();
    }

    public onTimeGroupSwitch(data, event){

        this.getTemplateViewModel().timeGroupSwitch(data);
        this.caller.getReportData();
    }

    public onDimensionGroupSwitch(data, event){

        this.getTemplateViewModel().dimensionGroupSwitch(data);
        this.caller.getReportData();
    }

    public onRangeGroupSwitch(data, event){

        this.getTemplateViewModel().rangeGroupSwitch(data);
        this.caller.getReportData();
    }

    protected onMouseOverPreset(){

        this.getTemplateViewModel().isPresetVisible(true);
    }

    protected onMouseOutPreset(){

        this.getTemplateViewModel().isPresetVisible(false);
    }

    public setResultPage(nbResults, nbPages, execTime) {
        this.resultsInfo.setExecutionTime(execTime);
        this.resultsInfo.setNbResults(nbResults);
        this.resultsInfo.setNbPages(nbPages);
    }

    public setReferrer(referrer){

        this.getTemplateViewModel().referrer(referrer);
    }

    private onClickBack(){

        page(this.getTemplateViewModel().referrer());
    }

    private onPermalinkInputChange(data, event){

        this.getTemplateViewModel().permalink(event.target.value);
        this.caller.getReportData();
    }

    public updateIndicatorsGraphData(){

        this.viewsChart.setCssHeight("230px");

        let chartData = this.getTemplateViewModel().indicatorsDateRange().data;

        this.viewsChart.setDeviceView(this.getTemplateViewModel().deviceView());
        this.viewsChart.setDateFormat(this.getTemplateViewModel().timeGroupSwitch());
        this.viewsChart.setDateFields(["dateData"]);
        this.viewsChart.setCursorEnabled(1);
        this.viewsChart.setLabelMaxWidth(80);
        this.viewsChart.setAutoRotateLabels(0);
        this.viewsChart.setClickableLegend(1);
        this.viewsChart.setXScrollbarEnabled(0);

        let chart = this.viewsChart.setupChart(chartData);

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        this.viewsChart.applyValueAxisFormatting(valueAxis);
        valueAxis.renderer.minWidth = 50;
        valueAxis.renderer.grid.template.disabled = true;

        valueAxis.title.fontWeight = "bold";
        valueAxis.min = 0;

        let graphLines = this.getTemplateViewModel().graphLines();
        let count = 0;
        for (let graphLine of graphLines) {
        
            let series = chart.series.push(new am4charts.LineSeries());

            let color = permalinkDetails_template.getPaletteColor(count);

            series.dataItems.template.locations.categoryX = 0.5;
            series.dataFields.valueY =  graphLine.value;
            series.dataFields.customValue = graphLine.value;
            series.dataFields.dateX = graphLine.field;
            series.strokeOpacity = 1;
            series.strokeWidth = 2;
            series.fill = am4core.color(color);
            series.stroke = am4core.color(color);
            series.yAxis = valueAxis;
            series.name = graphLine.name;

            series.tooltipText = "{name}: [bold]{customValue}[/]";
            series.smoothing = "monotoneX";
            series.showOnInit = true;

            let interfaceColors = new am4core.InterfaceColorSet();

            let bullet = series.bullets.push(new am4charts.CircleBullet());
            bullet.circle.radius = 4;
            bullet.circle.opacity = 1;
            bullet.circle.strokeWidth = 1;
            bullet.circle.stroke = interfaceColors.getFor("background");
            bullet.circle.opacity = 1;
            bullet.circle.strokeOpacity = 0.9;

            series.minBulletDistance = 2.5;

            count++;
        }

        valueAxis.numberFormatter.numberFormat = "#a";
        valueAxis.tooltip.disabled = true;  // Disable Y-axis tooltip

        //responsive mobile
        chart.responsive.useDefault = false;
        chart.responsive.enabled = true;

        chart.responsive.rules.push({
          relevant: function(target) {
            if (target.pixelWidth <= 768) {
              return true;
            }

            return false;
          },
          state: function(target, stateId) {
            if (target instanceof am4charts.Chart) {
              var state = target.states.create(stateId);
              chart.legend.markers.template.disabled = true;
              chart.legend.labels.template.disabled = true;
              return state;
            }
            return null;
          }
        });

        // kill pading
        chart.paddingTop = 20;
        chart.paddingBottom = 0;
        chart.paddingLeft = 0;
        chart.paddingRight = 20;

        chart.events.once("ready", () => {

            for (let annotation of this.getTemplateViewModel().timelineAnnotationsData()) {

                // Use the axis of a known series to choose the correct x-axis (you have multiple).
                const series0 = chart.series.getIndex(0) as am4charts.LineSeries;
                if (!series0 || !series0.xAxis) return;

                // Cast the axis to DateAxis so TS knows about min/max, strictMinMax, etc.
                const xAxis = series0.xAxis as am4charts.DateAxis;

                // The moment you want to mark:
                let eventDateTmp = annotation.date;


                let lineOffset = 43200000;
                if (this.getTemplateViewModel().timeGroupSwitch() == "hourly") {

                    lineOffset = 1800000;
                }else {

                    eventDateTmp.setHours(0, 0, 0, 0);
                }

                let offset = (eventDateTmp.getTimezoneOffset() * 60 * 1000);


                let eventDate = new Date(eventDateTmp.getTime() - offset + lineOffset);


                const ts = +eventDate;

                // Create the range and cast it to DateAxisDataItem so .value/.date are valid
                const range = xAxis.axisRanges.create() as am4charts.DateAxisDataItem;

                // Either set value (timestamp) or date (Date) — both are valid on DateAxisDataItem
                range.value = ts;              // or: range.date = eventDate;

                // Style the line
                range.grid.stroke = am4core.color("#FF0000");
                range.grid.strokeWidth = 2;
                range.grid.strokeOpacity = 1;
                range.grid.strokeDasharray = "4,4";
                range.grid.zIndex = 1000;

                // Label / note
                //range.label.text = "Annotation";
                range.label.rotation = -90;
                range.label.horizontalCenter = "right";
                range.label.verticalCenter = "bottom";
                range.label.dy = -150;                     // tweak up/down if needed

                range.label.inside = true;
                range.label.fill = am4core.color("#D41C5C");
                range.label.padding(0, 6, 0, 6);
            }
        });

        if(chart.logo){

            chart.logo.disabled = true;
        }
    }

    static getPaletteColor(number) {
        switch(number) {
            case 0:
                return "#312D69";
            case 1:
                return "#D8366D";
            case 2:
                return "#1CA71C"; // Bold Green
            case 3:
                return "#FB0D0D"; // Vivid Red
            case 4:
                return "#DA16FF"; // Purple
            case 5:
                return "#222A2A"; // Dark Gray
            case 6:
                return "#FFC800"; // Bright Yellow
            case 7:
                return "#00C49A"; // Teal
            case 8:
                return "#FF5733"; // Orange-Red
            case 9:
                return "#6A329F"; // Deep Purple
            default:
                return "#000000";  // Default case if number doesn't match any case
        }
    }

    static stringToColour(str){

        let hash = 0;
        for (let i = 0; i < str.length; i++){

            hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }

        let colour = '#';
        for (let i = 0; i < 3; i++){

            let value = (hash >> (i * 8)) & 0xFF;
            colour += ('00' + value.toString(16)).substr(-2);
        }

        return colour;
    }

    public setViewModelFromRequest(params : Array<any>): void{

        if(typeof params['permalink'] !== 'undefined'){

            this.getTemplateViewModel().permalink(params['permalink']);
            console.log(params['permalink'])
        }

        if(typeof params['brand'] !== 'undefined'){

            this.getTemplateViewModel().brand(params['brand']);
        }

        if(typeof params['indicatorGroupSwitch'] !== 'undefined'){

            this.metricFilter.setSelectedOption(params['indicatorGroupSwitch']);
            this.getTemplateViewModel().indicatorGroupSwitch(params['indicatorGroupSwitch']);
        }

        if(typeof params['indicatorGroupSwitchText'] !== 'undefined'){

            this.metricFilter.setSelectedOptionText(params['indicatorGroupSwitchText']);
        }

        if(typeof params['timeGroupSwitch'] !== 'undefined'){

            this.getTemplateViewModel().timeGroupSwitch(params['timeGroupSwitch']);
        }

        if(typeof params['dimensionGroupSwitch'] !== 'undefined'){

            this.getTemplateViewModel().dimensionGroupSwitch(params['dimensionGroupSwitch']);
        }

        if(typeof params['rangeGroupSwitch'] !== 'undefined'){

            this.rangeFilter.setSelectedOption(params['rangeGroupSwitch']);
        }

        if(typeof params['rangeGroupSwitchText'] !== 'undefined'){

            this.rangeFilter.setSelectedOptionText(params['rangeGroupSwitchText']);
        }

        this.presetFilter.setDates(this.dateRangeFilter, params['dateFilterType'], params['startDate'], params['endDate'], params['startDateRange'], params['endDateRange']);

        if(typeof params['selectedDynamicFilters'] !== 'undefined' && Array.isArray(params['selectedDynamicFilters'])){

            let dynamicFilters = this.getTemplateViewModel().dynamicFilters();
            dynamicFilterOperators.restore(dynamicFilters, params['selectedDynamicFilters']);

            params['selectedDynamicFilters'].forEach(selectedDynamicFilter => {

                Object.values(selectedDynamicFilter).forEach(category => {

                    if (typeof category === 'object' && category !== null) {

                        Object.values(category).forEach(categoryFilter => {

                            let dynamicFilter = dynamicFilters.find(obj => obj.filter.idElement === categoryFilter.id);

                            if (dynamicFilter) {

                                let filter = dynamicFilter.filter;

                                if(categoryFilter.type === 'multiSelect'){

                                    if(categoryFilter.items.length > 0 || categoryFilter.keyword != ''){

                                        let filterIds = categoryFilter.items.map(obj => obj.id);
                                        this.presetFilter.setMultiSelectorPresetFilters(filter, filterIds, categoryFilter.keyword);
                                    }
                                }
                                else if(categoryFilter.type === 'autoCompleteMultiSelect'){

                                    if(categoryFilter.items.length > 0 || categoryFilter.keyword != ''){

                                        let filterIds = categoryFilter.items.map(obj => obj.id);
                                        let filterNames = categoryFilter.items.map(obj => obj.name);
                                        this.presetFilter.setMultipleAutocompletePresetFilter(filter, filterIds, filterNames, categoryFilter.keyword);
                                    }
                                }
                                else if(categoryFilter.type === 'searchField'){

                                    if(categoryFilter.keyword != ''){

                                        filter.getTemplateViewModel().filterKeyword(categoryFilter.keyword);
                                    }
                                    
                                }
                            }
                        });
                    }
                });

            });

            this.getTemplateViewModel().dynamicFilters(dynamicFilters);
        }

    }

    private isDateDifferenceWithinDays(startDate, endDate, numDays) {

        const dateA = new Date(startDate);
        const dateB = new Date(endDate);

        const diffInMs = Math.abs(dateA.getTime() - dateB.getTime());
        const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

        return (diffInDays + 1) <= numDays;
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/permalinkDetails_template.ts